import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import EmailAddressList from '../components/EmailAddressList'

export default connect(
  (state: ApplicationState) =>
    createStructuredSelector<ApplicationState, IGlobalConfigurationState>({
      configuration: selectConfiguration(),
    }),
  {},
)(EmailAddressList)
